import { Box } from 'native-base';
import React, { useMemo } from 'react';
import { useAdditionalLinks } from '../../hooks/data/useAdditionalLinks';
import { Link } from '../../models/view';
import { colors } from '../../styles';
import { AltLinkCard, Section } from '../ui';

export interface AdditionalLinksListItemProps {
  link: Link;
}

export const AdditionalLinksListItem: React.FC<AdditionalLinksListItemProps> = ({ link }) => {
  return <AltLinkCard iconName={link.iconName} title={link.title} url={link.url} iconColor={colors.primary} />;
};

export interface AdditionalLinksListProps {
  types: string[];
}

export const AdditionalLinksList: React.FC<AdditionalLinksListProps> = ({ types }) => {
  const { additionalLinks } = useAdditionalLinks();

  const filteredLinks = useMemo(() => {
    return additionalLinks.filter((link) => {
      if (link.type === undefined || link.type === null) return true;

      if (types.includes(link.type)) return true;

      return false;
    });
  }, [types]);

  if (filteredLinks.length === 0) {
    return null;
  }

  return (
    <Section title="Additional Links" hideIcon>
      <Box>
        {filteredLinks
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((link) => (
            <Box mb={-2} key={link.id}>
              <AdditionalLinksListItem link={link} />
            </Box>
          ))}
      </Box>
    </Section>
  );
};
